import { Record } from 'immutable';
const DisabledInteractionsConfigRecord = Record({
  isCreateArticleTemporarilyDisabled: false,
  isImportTemporarilyDisabled: false,
  isPublishArticleTemporarilyDisabled: false,
  isRequesting: false,
  lastLoaded: undefined
});
export default DisabledInteractionsConfigRecord;